import {VolatilityMoversService} from "./service/VolatilityMoversService";
import {compactVolMovers, CompactVolMovers} from "./content/vol/CompactVolMovers";

export default angular.module("tfApp.components.watchlist", [])
                      .component(CompactVolMovers, compactVolMovers())
                      .service(VolatilityMoversService.id, VolatilityMoversService)
                      .name;
